<template>
  <div
    id="pageRoot"
    class="backgroundDeaf"
    style="background-color: var(--book-background-color)"
  >
    <!-- TEXTOS -------------------------------------------------------------------------------------------------------
					<p class="pageTextNormalDeaf" style="margin-left: 33%; margin-top: 15.5%;">
						ESTOS SON MIS AMIGOS:
					</p>
					<p class="pageTextBigDeaf" style="margin-left: 32%; margin-top: 19%; font-size: 32px">
						GUAZUBIRÁ Y MULITA.
					</p>
					<p class="pageTextNormalDeaf" style="margin-left: 45%; margin-top: 58%; text-align:center;">
						YO VIVO EN UNA<br>
						MADRIGUERA.
					</p>
					<p class="pageTextNormalDeaf" style="margin-left: 30.5%; margin-top: 91.5%; text-align:center;">
						AQUÍ ESTOY<br>
						CON MI FAMILIA.
					</p>
					TEXTOS -------------------------------------------------------------------------------------------------------->
    <img
      id="zorrito"
      class="pageElement basicItem01"
      src="/pages/img/intro/svgZorrito02.svg"
    />
    <img
      id="globe01"
      class="pageElement text-box-a hover-animation-a"
      src="/pages/img/intro/svg02Globe01.svg"
    />
    <img
      id="zorritoWrite"
      class="pageElement hover-animation-a"
      src="/pages/img/intro/svgZorritoWrite.svg"
    />
    <h2 id="text01">
      <span class="bold">...CON UN LAPIZ,</span><br />
      TE INVITO A ESCRIBIR.
    </h2>
    <img
      id="zorritoListen"
      class="pageElement hover-animation-a"
      src="/pages/img/intro/svgZorritoListen.svg"
    />
    <h2 id="text02">
      <span class="bold">...CON LA MANO EN LA OREJA,</span><br />
      TE INVITO A COMPARTIR<br />
      UNA LECTURA
    </h2>
    <img
      id="zorritoRead"
      class="pageElement hover-animation-a"
      src="/pages/img/intro/svgZorritoRead.svg"
    />
    <h2 id="text03">
      <span class="bold">...CON UN LIBRO,</span><br />
      TE INVITO A LEER.
    </h2>
  </div>
</template>
<style scoped>
.bold {
  font-weight: bold;
}
#zorrito {
  position: absolute;
  left: 52px;
  top: 53px;
}
#globe01 {
  position: absolute;
  left: 453px;
  top: 215px;
  z-index: 2;
}
#zorritoWrite {
  position: absolute;
  left: 10px;
  top: 391px;
}
#zorritoListen {
  position: absolute;
  left: 423px;
  top: 424px;
  z-index: 0;
}
#zorritoRead {
  position: absolute;
  left: 775px;
  top: 363px;
}
#text01 {
  position: absolute;
  left: 57px;
  top: 635px;
  text-align: center;
}
#text02 {
  position: absolute;
  left: 383px;
  top: 635px;
  text-align: center;
  z-index: 1;
}
#text03 {
  position: absolute;
  left: 802px;
  top: 635px;
  text-align: center;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["p6/V4A.mp4"]
    }
  }
}
</script>